// src/pages/usa/puertorico/Aguadilla.js
import "../../../App.css";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import BackOnly from "../../../components/BackOnly";
import ContactPopup from "../../../components/ContactPopup";
import React, { useState, useEffect } from "react";
import AffiliateBooking from "../../../components/affiliate/AffiliateBooking";
import AffiliateExpedia from "../../../components/affiliate/AffiliateExpedia";
import AffiliateTrip from "../../../components/affiliate/AffiliateTrip";

import { useNavigate } from "react-router-dom";   // ⭐ REQUIRED

// ⭐ STRICT COMMAND: Adjuntas ALWAYS goes back to Puerto Rico map
export const backRoute = "/map/puertorico";

export default function Adjuntas() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  // ⭐ Send strict back command to BackOnly
  useEffect(() => {
    navigate(".", { state: { backRoute } });
  }, [navigate]);

  return (
    <>
      <Header />

      <div className="visited-back-wrapper">
        <BackOnly />
      </div>


      <div className="page-container" style={{ padding: "12px" }}>
        <h1>Adjuntas, Puerto Rico</h1>

        <section className="travel-review">
          {/* LEFT COLUMN */}
          <div className="travel-text">
            <h2>🏞️ Discover Adjuntas, Puerto Rico</h2>

<p>
  Adjuntas is a municipality located in the mountainous interior of Puerto Rico, known for 
  its amazing landscapes, waterfalls, rivers and outdoor recreational activities. It offers a 
  peaceful retreat from the bustling cities, with opportunities for hiking, birdwatching, and
   exploring natural springs.
</p>


            <h3>🚗 Getting There</h3>

<p>
  Adjuntas is located in the mountainous heart of Puerto Rico, and getting 
  there is part of the experience — the drive takes you through cool 
  high‑elevation forests, winding roads, and beautiful countryside views. 
  Whether you're coming from San Juan, Utuado, Ponce, or Lares, the routes 
  are well‑marked and easy to follow.
</p>

<p>
  <strong>From San Juan:</strong> The drive takes about <strong>2 to 2.5 hours</strong>. 
  Take <strong>PR‑22</strong> west toward Arecibo, then connect to 
  <strong>PR‑10 south</strong> toward Utuado. From there, follow the signs to 
  <strong>PR‑123</strong> into Adjuntas. This is the most common and smoothest 
  route, with great mountain scenery along the way.
</p>

<p>
  <strong>From Ponce:</strong> Driving from Ponce takes about 
  <strong>35–45 minutes</strong>. Take <strong>PR‑123 north</strong> straight 
  into Adjuntas. This route climbs steadily into the mountains and is one of 
  the easiest ways to reach the town.
</p>

<p>
  <strong>From Lares:</strong> The drive from Lares takes about 
  <strong>25–30 minutes</strong>. Follow <strong>PR‑129</strong> and connect 
  to <strong>PR‑135</strong> or <strong>PR‑128</strong> depending on your 
  starting point. These roads are scenic and pass through small rural 
  communities before reaching Adjuntas.
</p>

<p>
  No matter which direction you come from, Adjuntas welcomes you with cooler 
  temperatures, mountain landscapes, coffee farms, and one of the most 
  peaceful atmospheres in Puerto Rico.
</p>



            <h3>🌟 My Personal Observation</h3>

<ul>
  <li>
    <div className="place-block">
      <strong>The Town:</strong> Adjuntas is a small, charming town with a central plaza, local
       shops, and a few restaurants. The town is known for its coffee production, and you can find
        local coffee shops and small cafes that serve fresh Puerto Rican coffee.
   
    </div>
  </li>

  <li>
    <div className="place-block">
  <strong>Hacienda Sotomayor:</strong> The Hacienda Sotomayor is a nice place to visit in Adjuntas. 
  It is a quiet place to rest, enjoy the scenery, and learn about the history of coffee production 
  in Puerto Rico.
  <br />
  <a
    href="https://www.google.com/maps?q=18.172144136470394,-66.73820511901879"
    target="_blank"
    rel="noopener noreferrer"
  >
    📍 View on Google Maps
  </a>
</div>

  </li>

  <li>
   <div className="place-block">
  <strong>Charco Ataúd:</strong> Charco Ataúd is a natural swimming hole located in the 
  mountains of Adjuntas. It is a popular spot for locals and visitors to cool off, 
  relax, and enjoy the natural beauty of the area. The water is clear and refreshing, 
  and the surrounding forest provides a peaceful atmosphere.
  <br />
  <a
    href="https://www.google.com/maps?q=18.15411217200328,-66.74025214639617"
    target="_blank"
    rel="noopener noreferrer"
  >
    📍 View on Google Maps
  </a>
</div>

  </li>

  <li>
   <div className="place-block">
  <strong>Monte Guilarte:</strong> Monte Guilarte is one of the highest peaks in Puerto Rico, 
  located near Adjuntas. It is a great destination for hiking and enjoying panoramic views of 
  the island. The area is part of the Guilarte State Forest, which is home to diverse flora 
  and fauna. The hike to the summit is moderately challenging, but the views from the top are 
  worth the effort. The distance is approximately 1.5 miles. The elevation gain is approximately 
  650 feet from the base to the summit. The trail is well‑marked and maintained, making it 
  accessible for most hikers.
  <br />
  <a
    href="https://www.google.com/maps?q=18.145130084404666,-66.76758620914181"
    target="_blank"
    rel="noopener noreferrer"
  >
    📍 View on Google Maps
  </a>
</div>

  </li>

</ul>


           <h3>🥾 Other Hidden Gems</h3>

<ul>
  <li>
    <div className="place-block">
      <strong>Lago Garzas:</strong>
      <br />
      A peaceful mountain lake surrounded by dense forest and cool breezes. 
      It’s a great spot for photography, picnics, and enjoying quiet nature. 
      The area has several viewpoints and small trails that make it perfect 
      for a relaxing afternoon.
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Casa Pueblo:</strong>
      <br />
      A community‑run environmental and cultural center powered entirely by 
      solar energy. Casa Pueblo promotes conservation, local art, and 
      sustainable living. Visitors can explore exhibits, learn about 
      environmental projects, and support local artisans.
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Hacienda Tres Ángeles Coffee Farm:</strong>
      <br />
      A beautiful, family‑owned coffee farm offering guided tours, tastings, 
      and mountain views. It’s one of the best places in Puerto Rico to learn 
      about specialty coffee production while enjoying a peaceful rural setting.
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Fiestas Patronales de Adjuntas:</strong>
      <br />
      Celebrated in honor of <strong>San Joaquín</strong>, usually in 
      <strong> August</strong>. The festival includes live music, artisans, 
      traditional food, rides, and cultural activities in the town plaza. 
      It’s one of the most vibrant community events in the central mountains.
    </div>
  </li>

</ul>



            <h3>🛏️ Places to Stay in Adjuntas</h3>

<p>
  Adjuntas offers peaceful mountain lodges, rustic cabins, and nature‑focused 
  stays perfect for travelers looking to enjoy cool weather, coffee country, 
  and quiet forest surroundings. All of the stays listed below are available 
  on <strong>Expedia</strong> (priority) and <strong>Booking.com</strong>. 
  Always double‑check availability and reviews before booking.
</p>

<ul>

  <li>
    <div className="place-block">
      <strong>Parador Villas Sotomayor:</strong>
      A popular mountain resort with cabins, a pool, horseback riding, 
      hiking trails, and a peaceful forest setting. Great for families 
      and nature lovers.
      <br />
      <em>Available on Expedia & Booking.com</em>
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Monte Sagrado Reserve:</strong>
      A beautiful eco‑style mountain retreat offering modern cabins, 
      panoramic views, and a quiet atmosphere surrounded by nature.
      <br />
      <em>Available on Expedia & Booking.com</em>
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Casa del Lago Garzas:</strong>
      A lakeside stay near Lago Garzas with rustic charm, cool breezes, 
      and easy access to hiking and scenic viewpoints.
      <br />
      <em>Available on Expedia & Booking.com</em>
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Hacienda Negrón (near Adjuntas):</strong>
      Located just outside Adjuntas, this mountain hotel offers cabins, 
      a pool, river access, and a relaxing countryside atmosphere.
      <br />
      <em>Available on Expedia & Booking.com</em>
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Mountain Lodges & Cabins (Various Hosts):</strong>
      Adjuntas has several small private cabins and mountain lodges 
      available through major booking platforms. These offer privacy, 
      forest views, and a peaceful escape from the city.
      <br />
      <em>Available on Expedia & Booking.com</em>
    </div>
  </li>

</ul>



            <h3>If you are looking for a place to stay, you can check prices, date and time here.</h3>
            <div className="affiliate-block">
              <AffiliateExpedia />
              <AffiliateBooking />
              <AffiliateTrip />
            </div>

            <h3>🎥 My Travel Videos</h3>

            <p>
              Here is the video of the Charco Ataud.
            </p>

            <p>
              <a
                href="https://youtu.be/pZnkGyidujQ?si=N9FLr85lqV6sdHLL"
                target="_blank"
                rel="noopener noreferrer"
              >
                Charco Ataud (YouTube Video)
              </a>
            </p>


          </div>

          {/* RIGHT COLUMN */}
          <div className="travel-image-column">
            <a
              href="https://youtu.be/pZnkGyidujQ?si=N9FLr85lqV6sdHLL"
              target="_blank"
              rel="noopener noreferrer"
              className="youtube-image-card"
            >
              <img
                src="/images/usa/puertorico/adjuntas/ca1.jpg"
                alt="Charco Ataud"
              />
            </a>

           
            <img
              src="/images/usa/puertorico/adjuntas/ca2.jpg"
              alt="Charco Ataud"
            />
            <img
              src="/images/usa/puertorico/adjuntas/ca3.jpg"
              alt="Charco Ataud"
            />
            <img
              src="/images/usa/puertorico/adjuntas/cg2.jpg"
              alt="Monte Guilarte"
            />
            <img
              src="/images/usa/puertorico/adjuntas/mg1.jpg"
              alt="Monte Guilarte"
            />
             <img
              src="/images/usa/puertorico/adjuntas/mg2.jpg"
              alt="Monte Guilarte"
            />
             <img
              src="/images/usa/puertorico/adjuntas/mg3.jpg"
              alt="Monte Guilarte"
            />
             <img
              src="/images/usa/puertorico/adjuntas/mg4.jpg"
              alt="Monte Guilarte"
            />
             <img
              src="/images/usa/puertorico/adjuntas/plaza1.jpg"
              alt="Plaza Principal"
            />
             <img
              src="/images/usa/puertorico/adjuntas/plaza2.jpg"
              alt="Plaza Principal"
            />
             <img
              src="/images/usa/puertorico/adjuntas/plaza3.jpg"
              alt="Plaza Principal"
            />
            <img
              src="/images/usa/puertorico/adjuntas/rio.jpg"
              alt="River"
            />
            <img
              src="/images/usa/puertorico/adjuntas/sign.jpg"
              alt="Sign"
            />
           


          </div>
        </section>
      </div>

      <div className="email-wrapper">
        <button className="email-link" onClick={() => setOpen(true)}>
          contact@thefindingspot.com
        </button>
      </div>

      <ContactPopup isOpen={open} onClose={() => setOpen(false)} />

      <Footer />
    </>
  );
}
